import {showMagnetBtnByElement} from '../common/help_functions';

export function initSingleInsights() {
    const buttons = document.querySelectorAll(".single-insight-btn");
    buttons.forEach(button => showMagnetBtnByElement(button));
}